// extracted by mini-css-extract-plugin
module.exports = {"title":"d2j27ebS","card":"Fcn0T8tL","section":"tmNEu64r","styledModal":"MRwNggZt","alert":"JKVun9Rq"};